"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

var greenBase = '#559C56';
var green = {
  dark40: (0, _shader["default"])(-0.4, greenBase),
  //#0D180D
  dark30: (0, _shader["default"])(-0.3, greenBase),
  //#1F391F
  dark20: (0, _shader["default"])(-0.2, greenBase),
  //#315A32
  dark10: (0, _shader["default"])(-0.1, greenBase),
  //#437B44
  base: greenBase,
  light10: (0, _shader["default"])(0.1, greenBase),
  //#72B273
  light20: (0, _shader["default"])(0.2, greenBase),
  //#93C494
  light30: (0, _shader["default"])(0.3, greenBase),
  //#B4D6B4
  light40: (0, _shader["default"])(0.4, greenBase),
  //#D5E8D5
  light45: (0, _shader["default"])(0.45, greenBase) //#E5F1E6

};
var _default = green;
exports["default"] = _default;